module.exports = __webpack_public_path__ + "static/media/moonie-nft.18dddad2.svg";